import React from 'react'
import { Handle, Position } from 'reactflow'

export function ChatbotTargetHandle(props) {
  const hidden = !!props.hidden
  const style = hidden
    ? Object.assign({}, props.style || {}, { opacity: 0, pointerEvents: 'none' })
    : props.style
  return (
    <Handle
      type='target'
      position={Position.Left}
      isConnectable={!hidden}
      style={style}
    />
  )
}
